<template>
    <div>
        <div
            v-for="item in value"
            :key="item.attrId"
        >
            <ExtAttrItem
                :ref="`attrRef${item.attrId}`"
                :attr="item"
                :show-error-msg="false"
                style="display: inline-block"
                :disabled="disabled"
            />

            <div
                v-if="item.attrId === 1200000088"
                class="tip"
            >
                如无可选项，请选择“其他品牌”
            </div>

            <SgRecommend
                :recommend-list="item.recommendValues"
                :selected-values.sync="item.selectedValues"
            />

            <Quality :quality-list="item.reason || []" />
        </div>
    </div>
</template>

<script>
import { getCurrentInstance } from '@vue/composition-api';
import ExtAttrItem from './ExtAttrItem';
import SgRecommend from './SgRecommend';
import Quality from './Quality';

export default {
    name: 'SgExtAttrWrap',

    components: {
        ExtAttrItem,
        SgRecommend,
        Quality,
    },

    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        const { proxy, props } = getCurrentInstance();

        // 验证扩展属性
        const validate = () => {
            // 使用map遍历props.value，调用每一项对应的ExtAttrItem组件的validate方法进行验证
            // 使用filter过滤出有错误信息的项，得到一个包含所有错误信息的数组
            const errors = props.value.map((item) => proxy.$refs[`attrRef${item.attrId}`][0].validate()).filter(Boolean);
            // 如果有错误信息，则使用message.error显示第一个错误信息
            if (errors.length) {
                proxy.$mc.message.error(errors[0]);
            }
            // 返回验证是否通过，如果errors数组长度为0，说明所有项都通过了验证，返回true，否则返回false
            return errors.length === 0;
        };

        return {
            validate,
        };
    },
};

</script>

<style scoped>
::v-deep .mtd-select {
    width: 500px;
}

.tip {
    margin: -10px 0 10px 120px;
    font-size: 12px;
    color: #999999;
}
</style>
